module.exports = vendor_4e3cb19615c62ace39f1;